module.exports = __webpack_public_path__ + "img/inv_en.b729cd7c.webp";